module.exports = __webpack_public_path__ + "static/media/thumbnail.6d0c4fee.jpg";